import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const filespaceProvisionResponseSchema = z.object({
    // covers create, delete, upgrade and migrate
    filespaceProvisionEnabled: z.boolean(),
});
export class FilespaceProvisionResponseDto extends createZodDto(filespaceProvisionResponseSchema) {
}
